module.exports = {
    defaultTitle: 'Usama Tahir',
    logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
    author: 'Usama Tahir',
    url: 'https://usamatahir.com',
    legalName: 'Usana Tahir',
    defaultDescription: 'I’m Usama and I’m a Javascript developer with expetise in React, Gatsby, Nextjs and Jamstack Artchitecture.',
    socialLinks: {
      twitter: 'http://www.twitter.com/usamatahir0',
      github: 'https://github.com/usaamatahir',
      linkedin: 'https://www.linkedin.com/in/usamatahir0/',
      instagram: 'https://instagram.com/usamatahir0',
    },
    googleAnalyticsID: 'UA-28935271-4',
    themeColor: '#6b63ff',
    backgroundColor: '#6b63ff',
    social: {
      facebook: 'usamatahir0',
      twitter: '@usamatahir0',
    },
    address: {
      city: 'Rahim Yar Khan',
      region: 'Islam',
      country: 'Pakistan',
      zipCode: '64200',
    },
    contact: {
      email: 'usamatahir8330@gmail.com',
      phone: '+923038330573',
    },
    foundingDate: '2021',
  };
  